import React from "react";
import Emptystate from "../../../images/new-images/empty-state.svg";

const Emptyassessment = () => {
  return (
    <React.Fragment>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img className="MyinvitationsEmptyImg" src={Emptystate} />
      </div>
      <h6 className="You-do-not-have-any-invitations-yet">
        There are no Assessments Assigned.
      </h6>
    </React.Fragment>
  );
};

export default Emptyassessment;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-assessments/empty-assessment.jsx